import { Injectable } from '@angular/core';
import { HttpClientService } from 'src/app/core/http/http-client';
// import { HttpClientService } from 'src/app/http-client';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private http: HttpClientService) { }

  saveFeedback(data) {
    data['isIpjCourse'] = true;
    return this.http.post(`users/feedback`, data);
  }

  updateFeedback(id, data) {
    data['isIpjCourse'] = true;
    return this.http.put(`users/feedback/update/dislike/${id}`, data);
  }
}
